import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
// fix(#432): web-loaded Inter Variable for the rounded display family.
// Imported before index.css so the @font-face declarations are parsed
// before the cascade resolves `--font-display` against `font-family`.
// `?url` resolves the content-hashed asset Vite emits so the <link
// rel="preload"> below references the real built path instead of a
// stale literal.
import interLatinUrl from '@fontsource-variable/inter/files/inter-latin-wght-normal.woff2?url'
import '@fontsource-variable/inter/wght.css'
import './index.css'
import App from './App.tsx'

// Preload the latin-subset variable font in parallel with the CSS so
// the brand resolves before first paint on a 3G connection. The hash
// in `interLatinUrl` is the only path the browser will accept.
const preloadLink = document.createElement('link')
preloadLink.rel = 'preload'
preloadLink.as = 'font'
preloadLink.type = 'font/woff2'
preloadLink.href = interLatinUrl
preloadLink.crossOrigin = 'anonymous'
document.head.appendChild(preloadLink)

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
